import React from "react";
import s from "./info-source.module.scss";

const InfoSource = (props) => {

    const mediaCount = 13;
    const kzCount = 5;
    const socialCount = 1;

    return (
        <div className={s.InfoSource}>
            <h1>{props.getValue('INFO_SOURCE') }</h1>
            <div className={s.countBlocks}>
                <div className={s.countBlock}>
                    <span className={s.labelText}>
                        { props.getValue('MEDIA_COUNT')}
                    </span>
                    <span className={s.count+" "+s.greenText}>
                        { mediaCount }K+
                    </span>
                </div>
                <div className={s.countBlock}>
                    <span className={s.labelText}>
                        { props.getValue('KZ_COUNT')}
                    </span>
                    <span className={s.count+" "+s.blueText}>
                        { kzCount }K+
                    </span>
                </div>
                <div className={s.countBlock}>
                    <span className={s.labelText}>
                        { props.getValue('SOCIAL_COUNT')}
                    </span>
                    <span className={s.count+" "+s.whiteText}>
                        { socialCount }M+
                    </span>
                </div>
            </div>
        </div>
    )
}
export default InfoSource; 